module.exports = __webpack_public_path__ + "img/instagram.7030b930.svg";